// Category and subcategory documents carry an `image` path from the DB that still points at the
// old PNG set. Map them to the current SVG icons by title, falling back to the DB image for any
// title added later.

const CATEGORY_ICONS: Record<string, string> = {
  Personal: 'img/icons/personal_protection_active_color.svg',
  General: 'img/icons/savings_misc_active_color.svg',
  Company: 'img/icons/workplace_policy_active_color.svg'
};

const SUB_CATEGORY_ICONS: Record<string, string> = {
  Life: 'img/icons/policy_life_active_color.svg',
  'Critical Illness': 'img/icons/policy_critical_illness_active_color.svg',
  Medical: 'img/icons/policy_medical_active_color.svg',
  Saving: 'img/icons/policy_saving_active_color.svg',
  'Provident Fund': 'img/icons/policy_provident_fund_active_color.svg',
  Accident: 'img/icons/policy_accident_active_color.svg',
  Home: 'img/icons/policy_home_active_color.svg',
  Maid: 'img/icons/policy_maid_active_color.svg',
  Mortgage: 'img/icons/policy_mortgage_active_color.svg',
  Motor: 'img/icons/policy_motor_active_color.svg',
  Travel: 'img/icons/policy_travel_active_color.svg',
  Other: 'img/icons/policy_other_active_color.svg'
};

interface IconSource {
  title?: string;
  image?: string;
}

export const getCategoryIcon = (category: IconSource): string | undefined =>
  (category.title && CATEGORY_ICONS[category.title]) || category.image;

export const getSubCategoryIcon = (subCategory: IconSource): string | undefined =>
  (subCategory.title && SUB_CATEGORY_ICONS[subCategory.title]) || subCategory.image;
